import { CALL_API } from "admin/middlewares/api";

export const LOANSTEP_BALANCES_REQUEST = "LOANSTEP_BALANCES_REQUEST";
export const LOANSTEP_BALANCES_SUCCESS = "LOANSTEP_BALANCES_SUCCESS";
export const LOANSTEP_BALANCES_ERROR = "LOANSTEP_BALANCES_ERROR";

export function loanstep_special_accounts_balances() {
  let uri = "/api/admin/loanstep/specialAccounts";

  return {
    [CALL_API]: {
      endpoint: uri,
      authenticatedRequest: true,
      types: [
        LOANSTEP_BALANCES_REQUEST,
        LOANSTEP_BALANCES_SUCCESS,
        LOANSTEP_BALANCES_ERROR,
      ],
    },
  };
}

export const LOANSTEP_SPECIAL_ACCOUNT_TRANSACTION_ORDERS_REQUEST =
  "LOANSTEP_SPECIAL_ACCOUNT_TRANSACTION_ORDERS_REQUEST";
export const LOANSTEP_SPECIAL_ACCOUNT_TRANSACTION_ORDERS_SUCCESS =
  "LOANSTEP_SPECIAL_ACCOUNT_TRANSACTION_ORDERS_SUCCESS";
export const LOANSTEP_SPECIAL_ACCOUNT_TRANSACTION_ORDERS_ERROR =
  "LOANSTEP_SPECIAL_ACCOUNT_TRANSACTION_ORDERS_ERROR";

export function loanstep_special_accounts_transaction_orders() {
  let uri = "/api/admin/loanstep/special-account-transaction-orders";

  return {
    [CALL_API]: {
      endpoint: uri,
      authenticatedRequest: true,
      types: [
        LOANSTEP_SPECIAL_ACCOUNT_TRANSACTION_ORDERS_REQUEST,
        LOANSTEP_SPECIAL_ACCOUNT_TRANSACTION_ORDERS_SUCCESS,
        LOANSTEP_SPECIAL_ACCOUNT_TRANSACTION_ORDERS_ERROR,
      ],
    },
  };
}

export const LOANSTEP_SPECIAL_ACCOUNT_DEPOSIT_REQUEST =
  "LOANSTEP_SPECIAL_ACCOUNT_DEPOSIT_REQUEST";
export const LOANSTEP_SPECIAL_ACCOUNT_DEPOSIT_SUCCESS =
  "LOANSTEP_SPECIAL_ACCOUNT_DEPOSIT_SUCCESS";
export const LOANSTEP_SPECIAL_ACCOUNT_DEPOSIT_ERROR =
  "LOANSTEP_SPECIAL_ACCOUNT_DEPOSIT_ERROR";

export function loanstep_create_deposit_order(amount, accountId, notes) {
  let uri = "/api/admin/loanstep/create-special-account-deposit-order";

  return {
    [CALL_API]: {
      endpoint: uri,
      method: "POST",
      authenticatedRequest: true,
      data: { Amount: amount, Account: accountId, Notes: notes },
      types: [
        LOANSTEP_SPECIAL_ACCOUNT_DEPOSIT_REQUEST,
        LOANSTEP_SPECIAL_ACCOUNT_DEPOSIT_SUCCESS,
        LOANSTEP_SPECIAL_ACCOUNT_DEPOSIT_ERROR,
      ],
    },
  };
}

export const LOANSTEP_SPECIAL_ACCOUNT_WITHDRAW_REQUEST =
  "LOANSTEP_SPECIAL_ACCOUNT_WITHDRAW_REQUEST";
export const LOANSTEP_SPECIAL_ACCOUNT_WITHDRAW_SUCCESS =
  "LOANSTEP_SPECIAL_ACCOUNT_WITHDRAW_SUCCESS";
export const LOANSTEP_SPECIAL_ACCOUNT_WITHDRAW_ERROR =
  "LOANSTEP_SPECIAL_ACCOUNT_WITHDRAW_ERROR";

export function loanstep_create_withdrawal_order(amount, accountId, notes) {
  let uri = "/api/admin/loanstep/create-special-account-withdrawal-order";

  return {
    [CALL_API]: {
      method: "POST",
      endpoint: uri,
      authenticatedRequest: true,
      data: { Amount: amount, Account: accountId, Notes: notes },
      types: [
        LOANSTEP_SPECIAL_ACCOUNT_WITHDRAW_REQUEST,
        LOANSTEP_SPECIAL_ACCOUNT_WITHDRAW_SUCCESS,
        LOANSTEP_SPECIAL_ACCOUNT_WITHDRAW_ERROR,
      ],
    },
  };
}

export const LOANSTEP_SPECIAL_ACCOUNT_TRANSACTION_CONFIRM_REQUEST =
  "LOANSTEP_SPECIAL_ACCOUNT_TRANSACTION_CONFIRM_REQUEST";
export const LOANSTEP_SPECIAL_ACCOUNT_TRANSACTION_CONFIRM_SUCCESS =
  "LOANSTEP_SPECIAL_ACCOUNT_TRANSACTION_CONFIRM_SUCCESS";
export const LOANSTEP_SPECIAL_ACCOUNT_TRANSACTION_CONFIRM_ERROR =
  "LOANSTEP_SPECIAL_ACCOUNT_TRANSACTION_CONFIRM_ERROR";

export function loanstep_confirm_transaction_order(id) {
  let uri = "/api/admin/loanstep/confirm-special-account-transaction-order";

  return {
    [CALL_API]: {
      method: "POST",
      endpoint: uri,
      authenticatedRequest: true,
      data: { Id: id },
      types: [
        LOANSTEP_SPECIAL_ACCOUNT_TRANSACTION_CONFIRM_REQUEST,
        LOANSTEP_SPECIAL_ACCOUNT_TRANSACTION_CONFIRM_SUCCESS,
        LOANSTEP_SPECIAL_ACCOUNT_TRANSACTION_CONFIRM_ERROR,
      ],
    },
  };
}

export const LOANSTEP_SPECIAL_ACCOUNT_TRANSACTION_CANCEL_REQUEST =
  "LOANSTEP_SPECIAL_ACCOUNT_TRANSACTION_CANCEL_REQUEST";
export const LOANSTEP_SPECIAL_ACCOUNT_TRANSACTION_CANCEL_SUCCESS =
  "LOANSTEP_SPECIAL_ACCOUNT_TRANSACTION_CANCEL_SUCCESS";
export const LOANSTEP_SPECIAL_ACCOUNT_TRANSACTION_CANCEL_ERROR =
  "LOANSTEP_SPECIAL_ACCOUNT_TRANSACTION_CANCEL_ERROR";

export function loanstep_cancel_transaction_order(id) {
  let uri = "/api/admin/loanstep/cancel-special-account-transaction-order";

  return {
    [CALL_API]: {
      method: "POST",
      endpoint: uri,
      authenticatedRequest: true,
      data: { Id: id },
      types: [
        LOANSTEP_SPECIAL_ACCOUNT_TRANSACTION_CANCEL_REQUEST,
        LOANSTEP_SPECIAL_ACCOUNT_TRANSACTION_CANCEL_SUCCESS,
        LOANSTEP_SPECIAL_ACCOUNT_TRANSACTION_CANCEL_ERROR,
      ],
    },
  };
}
